const CSRF_COOKIE_NAME = 'csrf_token';

let cachedLocalDevCsrfToken = '';
let inFlightLocalDevFetch = null;

const isLoopbackHost = (hostname) =>
  ['localhost', '127.0.0.1', '0.0.0.0', '::1'].includes(
    (hostname || '').toLowerCase(),
  );

const getCookieValue = (name) => {
  if (typeof document === 'undefined') return '';
  const prefix = `${name}=`;
  return (
    document.cookie
      .split('; ')
      .find((row) => row.startsWith(prefix))
      ?.slice(prefix.length) || ''
  );
};

export const getCsrfTokenFromCookie = () => getCookieValue(CSRF_COOKIE_NAME);

export const getCsrfToken = async (bffBase) => {
  const cookieToken = getCsrfTokenFromCookie();
  if (cookieToken) {
    cachedLocalDevCsrfToken = cookieToken;
    return cookieToken;
  }

  if (
    typeof window === 'undefined' ||
    !isLoopbackHost(window.location?.hostname) ||
    !bffBase
  ) {
    return '';
  }

  if (cachedLocalDevCsrfToken) return cachedLocalDevCsrfToken;

  if (!inFlightLocalDevFetch) {
    inFlightLocalDevFetch = fetch(`${bffBase}/api/v1/auth/csrf-token`, {
      method: 'GET',
      credentials: 'include',
      headers: { Accept: 'application/json' },
    })
      .then(async (response) => {
        if (!response.ok) return '';
        const data = await response.json().catch(() => ({}));
        cachedLocalDevCsrfToken =
          typeof data.csrfToken === 'string' ? data.csrfToken : '';
        return cachedLocalDevCsrfToken;
      })
      .catch(() => '')
      .finally(() => {
        inFlightLocalDevFetch = null;
      });
  }

  return inFlightLocalDevFetch;
};

export const clearCachedCsrfToken = () => {
  cachedLocalDevCsrfToken = '';
};
